if (!customElements.get('scroll-rail')) {
  customElements.define('scroll-rail', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      this.track = this.querySelector('[data-rail-track]');
      this.previous = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      if (!this.track || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.previous.hidden = max <= 2;
        this.next.hidden = max <= 2;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= max - 2;
      };
      this.move = (direction) => {
        const items = this.track.querySelectorAll('[data-rail-item]');
        const step = items.length > 1 ? Math.abs(items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left) : this.track.clientWidth;
        const distance = Math.max(1, Math.floor(this.track.clientWidth / step) - 1) * step;
        this.track.scrollBy({ left: direction * distance * (getComputedStyle(this.track).direction === 'rtl' ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      if (this.track.firstElementChild) this.observer.observe(this.track.firstElementChild);
      this.update();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
